var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = ["data-id"];
var _hoisted_2 = { class: "cart-prod__col cart-prod__col--main" };
var _hoisted_3 = ["data-id"];
var _hoisted_4 = ["href"];
var _hoisted_5 = {
    key: 2,
    class: "prod-line prod-line--extra"
};
var _hoisted_6 = {
    "data-label": "Скидка",
    class: "cart-prod__col"
};
var _hoisted_7 = {
    key: 0,
    class: "cart-prod__discount"
};
var _hoisted_8 = {
    "data-label": "Цена",
    class: "cart-prod__col"
};
var _hoisted_9 = { class: "cart-prod__prices" };
var _hoisted_10 = { class: "cart-prod__price-new" };
var _hoisted_11 = {
    key: 0,
    class: "cart-prod__price-old"
};
var _hoisted_12 = {
    "data-label": "Кол‑во",
    class: "cart-prod__col"
};
var _hoisted_13 = {
    "data-label": "Сумма",
    class: "cart-prod__col"
};
var _hoisted_14 = { class: "cart-prod__price-new" };
var _hoisted_15 = { class: "cart-prod__col cart-prod__col--remove" };
import { ref, watch } from "vue";
import CartEventBus from "../../CartEventBus";
import Button from "../../../../components/Button.vue";
import LoadingPrice from "../LoadingPrice.vue";
import TextContentLoading from "../TextContentLoading.vue";
import QuantityBox from "./QuantityBox.vue";
import CartItemInfo from "./CartItemInfo.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartItem',
    props: {
        initialized: Boolean,
        item: { type: Object, required: true },
    },
    setup: function (__props) {
        var props = __props;
        var quantity = ref(props.item.quantity);
        var sum = ref(props.item.sum);
        watch(function () { return props.item.quantity; }, function (newVal) {
            quantity.value = newVal;
        });
        watch(function () { return quantity.value; }, function (quantity, oldQuantity) {
            if (quantity !== props.item.quantity) {
                sum.value = props.item.price * quantity;
                CartEventBus.emit('products:quantity', { product: props.item, quantity: quantity, oldQuantity: oldQuantity });
            }
            else if (sum.value !== props.item.sum) {
                sum.value = props.item.sum;
            }
        });
        watch(function () { return props.item.sum; }, function (value) { return sum.value = value; });
        function remove(product) {
            CartEventBus.emit('products:delete', product);
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("tr", {
                class: "cart-prod",
                "data-id": __props.item.productId
            }, [
                _createElementVNode("td", _hoisted_2, [
                    (__props.item.category === 'user_set')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "prod-line prod-line--extra win",
                            href: "#",
                            "data-act": "user_set",
                            "data-id": __props.item.cartItemId,
                            "data-type": "cart"
                        }, [
                            _createVNode(CartItemInfo, { item: __props.item }, {
                                default: _withCtx(function () { return __spreadArray([], __read((_cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "prod-line__composition" }, "Посмотреть состав сета", -1 /* CACHED */)
                                ]))), false); }),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["item"])
                        ], 8 /* PROPS */, _hoisted_3))
                        : (__props.item.url)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "prod-line prod-line--extra",
                                href: __props.item.url
                            }, [
                                _createVNode(CartItemInfo, { item: __props.item }, null, 8 /* PROPS */, ["item"])
                            ], 8 /* PROPS */, _hoisted_4))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(CartItemInfo, { item: __props.item }, null, 8 /* PROPS */, ["item"])
                            ]))
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("td", _hoisted_6, [
                    (__props.item.fullPrice && __props.item.fullPrice !== __props.item.price)
                        ? (_openBlock(), _createBlock(TextContentLoading, {
                            key: 0,
                            width: "35",
                            height: "15",
                            loading: !__props.initialized
                        }, {
                            default: _withCtx(function () { return [
                                (__props.item.discountPercent)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.item.discountPercent ? "".concat(__props.item.discountPercent, "%") : ''), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ]; }),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["loading"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(LoadingPrice, {
                                amount: __props.item.price,
                                width: "65",
                                height: "15",
                                loading: !__props.initialized
                            }, null, 8 /* PROPS */, ["amount", "loading"])
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (__props.item.fullPrice && __props.item.fullPrice !== __props.item.price)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(LoadingPrice, {
                                    amount: __props.item.fullPrice,
                                    width: "50",
                                    height: "12",
                                    loading: !__props.initialized
                                }, null, 8 /* PROPS */, ["amount", "loading"])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _createElementVNode("td", _hoisted_12, [
                    _createVNode(QuantityBox, {
                        modelValue: quantity.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((quantity).value = $event); })
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createVNode(LoadingPrice, {
                            amount: sum.value,
                            width: "65",
                            height: "15",
                            loading: !__props.initialized
                        }, null, 8 /* PROPS */, ["amount", "loading"])
                    ])
                ]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _createElementVNode("td", _hoisted_15, [
                    _createVNode(Button, {
                        icon: "remove",
                        styling: "4",
                        onClick: _cache[1] || (_cache[1] = function ($event) { return (remove(__props.item)); })
                    })
                ])
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
